<app-modal-content>
    <div [innerHTML]="'CookiePopup.Text' | translate"></div>
</app-modal-content>
<app-modal-footer
        [primaryBtnTranslateKey]="'CookiePopup.Accept'"
        [primaryBtnIcon]="'check'"
        (primaryBtnClicked)="cookieAccepted()"
        [hideSecondaryButton]="true">
</app-modal-footer>
